import { useState, useEffect } from "react";
import { Box, Button, Dialog, DialogActions, DialogTitle, Grid, IconButton, Slide } from "@mui/material";
import Header from "../../components/Header";
import DebFormModal from "../../components/DebFormModal";
import { DebFormSelect, DebFormTextInput } from "../../components/DebFormComponents";
import DataTable from "../../components/DataTable";
import { company } from "../../services/companies";
import { appointmentsMobileConnection } from "../../services/appointments-mobile-connections";
import AddBoxIcon from "@mui/icons-material/AddBox";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import { useSnackbar } from "notistack";
import copy from 'copy-to-clipboard';
import { BugReport, ContentCopy } from "@mui/icons-material";
import { mobileConnectionsValidationSchema } from "../../schemas/appointments-mobile-connections";
import { MOBILE } from "../../constants/mobileConnectionTestSystems";

//TRANSICIÓN DEL ALERT DE ELIMINACIÓN
const Transition = React.forwardRef(function Transition(props, ref) {
    return <Slide direction="up" ref={ref} {...props} />;
  });

const newMobileConnectionValues = {
    id: "",
    urlMobile: "",
    company: {
        id: "",
    },
    userMobile: "",
    passwordMobile: "",
    tokenMobile: "",
};

const MobileConnections = () => {
    // MODAL DE EDICIÓN / CREACIÓN
    const [modalState, setModalState] = useState(false);
    const [modalInitialValues, setModalInitialValues] = useState(
        newMobileConnectionValues
    );
    const [mobileConnections, setMobileConnections] = useState([]);
    const [companies, setCompanies] = useState([]);

    const getMobileConnections = async () => {
        setMobileConnections(await appointmentsMobileConnection.getAll());
    };
    const getCompanies = async () => {
        setCompanies(await company.getAll());
    };

    useEffect(() => {
        getMobileConnections();
        getCompanies();
    }, []);

    const { enqueueSnackbar } = useSnackbar();

    const handleSubmit = async (values) => {
        try {
            if (values.id) {
                //estamos editando
                const res = await appointmentsMobileConnection.update(values);
                enqueueSnackbar("Conexión editada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            } else {
                const res = await appointmentsMobileConnection.create(values);
                enqueueSnackbar("Conexión creada", {
                    preventDuplicate: true,
                    variant: "success",
                });
            }
            closeModal();
            getMobileConnections();
        } catch (error) {
            if (values.id) {
                enqueueSnackbar("Ocurrió un error al editar la conexión", {
                    preventDuplicate: true,
                    variant: "error",
                });
            } else {
                enqueueSnackbar("Ocurrió un error al crear la conexión", {
                    preventDuplicate: true,
                    variant: "error",
                });
            }
        }
    };

    const openModal = () => {
        setModalState(true);
    };

    const closeModal = () => {
        setModalState(false);
        setModalInitialValues(newMobileConnectionValues);
    };

    const handleEdit = (mobileConnection) => {
        setModalInitialValues(mobileConnection);
        openModal();
    };
    const handleCreateMobileConnection = () => {
        setModalInitialValues(newMobileConnectionValues);
        openModal();
    };

    const handleTest = async (mobileConnection) => {

        const mobileTestBody = {
        id: mobileConnection.id,
        url: mobileConnection.urlMobile,
        token: mobileConnection.tokenMobile,
        system: MOBILE
        };

        try {
            const res = await appointmentsMobileConnection.testConnection(mobileTestBody);

            enqueueSnackbar("Test OK", {
                preventDuplicate: true,
                variant: "warning",
            });
        } catch (error) {
            enqueueSnackbar(`Error Status: ${error.response.status}`, {
                preventDuplicate: true,
                variant: "error",
            });
            enqueueSnackbar(error.response.data, {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

      // ALERT DE ELIMINACIÓN
        const [selectedDelete, setSelectedDelete] = useState();
        const [openAlert, setOpenAlert] = useState(false);
        const handleAlertClose = () => {
            setOpenAlert(false);
        };
        const handleAlertOpen = (selectedMobileConnection) => {
            setSelectedDelete(selectedMobileConnection);
            setOpenAlert(true);
        };

    const handleDelete = async () => {
        try {
            const res = await appointmentsMobileConnection.delete(
                selectedDelete.id
            );
            enqueueSnackbar(
                "Se eliminó la conexión con " +
                    selectedDelete.urlMobile,
                {
                    preventDuplicate: true,
                    variant: "success",
                }
            );
            handleAlertClose();
            getMobileConnections();
        } catch (error) {
            enqueueSnackbar("Ocurrió un error eliminando la conexión", {
                preventDuplicate: true,
                variant: "error",
            });
        }
    };

      //COPIAR TOKEN
        const handleCopy = (event, value) => {
            event.stopPropagation();
            copy(value);
            enqueueSnackbar(("Se copió el Token"), { 
            preventDuplicate: true, 
            variant: 'success'
        });
        };

    return (
        <Box>
            <Header
                title="CONEXIÓN CON MOBILE"
            />
            <DataTable
                loading={!mobileConnections.length}
                rows={mobileConnections}
                columns={[
                    { field: "id", headerName: "ID", flex: 0.1 },
                    {
                        field: "urlMobile",
                        headerName: "URL de Mobile",
                        flex: 0.7
                    },
                    {
                        field: "company.id",
                        headerName: "Compañía",
                        flex: 1,                        
                        renderCell: (params) => {
                            return params?.row?.company?.name ?? "";
                        },
                    },
                    {
                        field: "userMobile",
                        headerName: "Usuario",
                        flex: 1
                    },
                    {
                        field: "tokenMobile",
                        headerName: "Token",
                        flex: 1.2,
                        renderCell: (params) => (
                            <>
                              <IconButton
                                onClick={(event) => handleCopy(event, params?.value ?? "")}
                                aria-label="copy"
                              >
                                <ContentCopy />
                              </IconButton>
                              <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{params?.value ?? ""}</span>
                            </>
                          ),
                    },
                ]}
                rowActions={[
                    {
                        label: "Editar",
                        icon: <EditIcon />,
                        action: handleEdit,
                    },
                    {
                        label: "Eliminar",
                        icon: <DeleteIcon />,
                        action: handleAlertOpen
                    },
                    {
                        label: "Test",
                        icon: <BugReport />,
                        action: handleTest
                    },
                ]}
                headerActions={[
                    {
                        label: "Crear Conexión",
                        icon: <AddBoxIcon />,
                        action: handleCreateMobileConnection,
                    },
                ]}
            />

            {/* MODAL DE CREACIÓN / EDICIÓN DE CONEXIÓN MÓBIL */}
            <DebFormModal
                maxWidth="md"
                fullWidth={true}
                open={modalState}
                onClose={closeModal}
                onReject={closeModal}
                initialValues={modalInitialValues}
                onSubmit={handleSubmit}
                formikProps={{
                    enableReinitialize: true,
                    validationSchema: mobileConnectionsValidationSchema,
                }}
                headerText={
                    modalInitialValues?.id
                        ? "Editar Conexión"
                        : "Crear Conexión"
                }>
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                                <DebFormSelect
                                label={"Compañía"}
                                name={"company.id"}
                                selectOptions={Array.from(companies)?.map((company) => {
                                    return {
                                        value: company.id,
                                        label: company.name,
                                    };
                                })}
                                disabled={modalInitialValues.id ? true : false}
                                />  
                        </Grid>
                        <Grid item xs={6}>
                            <DebFormTextInput label={"URL Móbil"} name={"urlMobile"} />
                        </Grid>
                        <Grid item xs={6}>
                            <DebFormTextInput label={"Usuario"} name={"userMobile"} />
                        </Grid>
                        <Grid item xs={6}>
                                <DebFormTextInput
                                label={"Contraseña de servicio Mobile"}
                                name={"passwordMobile"}
                                type={"password"}
                            />
                        </Grid>
                        <Grid item xs={12}>
                                <DebFormTextInput
                                label={"Token de servicio Mobile"}
                                name={"tokenMobile"}
                            />
                        </Grid>
                    </Grid>
                    
            </DebFormModal>

            {/* ALERT DE ELIMINACIÓN */}
            <Dialog
                open={openAlert}
                TransitionComponent={Transition}
                keepMounted
                onClose={handleAlertClose}
                aria-describedby="alert-dialog-slide-description"
            >
                <DialogTitle sx={{m:"2rem 3rem 1rem 3rem", gap:"1rem", p:"0"}} >{"¿Esta seguro que desea eliminar?"}</DialogTitle>
                <DialogActions>
                <Button onClick={handleAlertClose} variant="outlined" color="error">Cancelar</Button>
                <Button onClick={handleDelete} variant="contained" color="success">Confirmar</Button>
                </DialogActions>
            </Dialog>
        </Box>
    );
};

export default MobileConnections;